import { useEffect, useMemo, useRef, useState } from "react";
import { useCommentUtils } from "./CommentElement";
export function useAddCommentAnnotation() {
    var commentElement = useCommentUtils();
    return {
        addCommentAnnotation: function (request) {
            return new Promise(function (resolve, reject) {
                if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.addCommentAnnotation))
                    return reject(new Error('Velt SDK is not initialized.'));
                commentElement.addCommentAnnotation(request).then(resolve).catch(reject);
            });
        }
    };
}
export function useApproveCommentAnnotation() {
    var commentElement = useCommentUtils();
    return {
        approveCommentAnnotation: function (request) {
            return new Promise(function (resolve, reject) {
                if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.approveCommentAnnotation))
                    return reject(new Error('Velt SDK is not initialized.'));
                commentElement.approveCommentAnnotation(request).then(resolve).catch(reject);
            });
        }
    };
}
export function useRejectCommentAnnotation() {
    var commentElement = useCommentUtils();
    return {
        rejectCommentAnnotation: function (request) {
            return new Promise(function (resolve, reject) {
                if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.rejectCommentAnnotation))
                    return reject(new Error('Velt SDK is not initialized.'));
                commentElement.rejectCommentAnnotation(request).then(resolve).catch(reject);
            });
        }
    };
}
export function useSubscribeCommentAnnotation() {
    var commentElement = useCommentUtils();
    return {
        subscribeCommentAnnotation: function (request) {
            return new Promise(function (resolve, reject) {
                if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.subscribeCommentAnnotation))
                    return reject(new Error('Velt SDK is not initialized.'));
                commentElement.subscribeCommentAnnotation(request).then(resolve).catch(reject);
            });
        }
    };
}
export function useUnsubscribeCommentAnnotation() {
    var commentElement = useCommentUtils();
    return {
        unsubscribeCommentAnnotation: function (request) {
            return new Promise(function (resolve, reject) {
                if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.unsubscribeCommentAnnotation))
                    return reject(new Error('Velt SDK is not initialized.'));
                commentElement.unsubscribeCommentAnnotation(request).then(resolve).catch(reject);
            });
        }
    };
}
export function useDeleteCommentAnnotation() {
    var commentElement = useCommentUtils();
    return {
        deleteCommentAnnotation: function (request) {
            return new Promise(function (resolve, reject) {
                if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.deleteCommentAnnotation))
                    return reject(new Error('Velt SDK is not initialized.'));
                commentElement.deleteCommentAnnotation(request).then(resolve).catch(reject);
            });
        }
    };
}
export function useGetCommentAnnotations(query) {
    var commentElement = useCommentUtils();
    var _a = useState({ data: null }), data = _a[0], setData = _a[1];
    var subscriptionRef = useRef();
    // Memoize the inputs
    var memoizedData = useMemo(function () {
        return query;
    }, [JSON.stringify(query)]);
    useEffect(function () {
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.getCommentAnnotations))
            return;
        // Unsubscribe from the previous subscription if it exists
        if (subscriptionRef.current) {
            subscriptionRef.current.unsubscribe();
        }
        var subscription = commentElement.getCommentAnnotations(memoizedData)
            .subscribe(function (res) {
            if (res) {
                setData(res);
            }
            else {
                setData({ data: null });
            }
        });
        // Store the new subscription
        subscriptionRef.current = subscription;
        // Cleanup function
        return function () {
            if (subscriptionRef.current) {
                subscriptionRef.current.unsubscribe();
            }
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.getCommentAnnotations, memoizedData]);
    return data;
}
export function useCommentAnnotationsCount(query) {
    var commentElement = useCommentUtils();
    var _a = useState({ data: null }), data = _a[0], setData = _a[1];
    var subscriptionRef = useRef();
    // Memoize the inputs
    var memoizedData = useMemo(function () {
        return query;
    }, [JSON.stringify(query)]);
    useEffect(function () {
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.getCommentAnnotationsCount))
            return;
        // Unsubscribe from the previous subscription if it exists
        if (subscriptionRef.current) {
            subscriptionRef.current.unsubscribe();
        }
        var subscription = commentElement.getCommentAnnotationsCount(memoizedData)
            .subscribe(function (res) {
            if (res) {
                setData(res);
            }
            else {
                setData({ data: null });
            }
        });
        // Store the new subscription
        subscriptionRef.current = subscription;
        // Cleanup function
        return function () {
            if (subscriptionRef.current) {
                subscriptionRef.current.unsubscribe();
            }
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.getCommentAnnotationsCount, memoizedData]);
    return data;
}
export function useAssignUser() {
    var commentElement = useCommentUtils();
    return {
        assignUser: function (request) {
            return new Promise(function (resolve, reject) {
                if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.assignUser))
                    return reject(new Error('Velt SDK is not initialized.'));
                commentElement.assignUser(request).then(resolve).catch(reject);
            });
        }
    };
}
export function useUpdatePriority() {
    var commentElement = useCommentUtils();
    return {
        updatePriority: function (request) {
            return new Promise(function (resolve, reject) {
                if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.updatePriority))
                    return reject(new Error('Velt SDK is not initialized.'));
                commentElement.updatePriority(request).then(resolve).catch(reject);
            });
        }
    };
}
export function useUpdateStatus() {
    var commentElement = useCommentUtils();
    return {
        updateStatus: function (request) {
            return new Promise(function (resolve, reject) {
                if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.updateStatus))
                    return reject(new Error('Velt SDK is not initialized.'));
                commentElement.updateStatus(request).then(resolve).catch(reject);
            });
        }
    };
}
export function useUpdateAccess() {
    var commentElement = useCommentUtils();
    return {
        updateAccess: function (request) {
            return new Promise(function (resolve, reject) {
                if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.updateAccess))
                    return reject(new Error('Velt SDK is not initialized.'));
                commentElement.updateAccess(request).then(resolve).catch(reject);
            });
        }
    };
}
export function useResolveCommentAnnotation() {
    var commentElement = useCommentUtils();
    return {
        resolveCommentAnnotation: function (request) {
            return new Promise(function (resolve, reject) {
                if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.resolveCommentAnnotation))
                    return reject(new Error('Velt SDK is not initialized.'));
                commentElement.resolveCommentAnnotation(request).then(resolve).catch(reject);
            });
        }
    };
}
export function useGetLink() {
    var commentElement = useCommentUtils();
    return {
        getLink: function (request) {
            return new Promise(function (resolve, reject) {
                if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.getLink))
                    return reject(new Error('Velt SDK is not initialized.'));
                commentElement.getLink(request).then(resolve).catch(reject);
            });
        }
    };
}
export function useCopyLink() {
    var commentElement = useCommentUtils();
    return {
        copyLink: function (request) {
            return new Promise(function (resolve, reject) {
                if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.copyLink))
                    return reject(new Error('Velt SDK is not initialized.'));
                commentElement.copyLink(request).then(resolve).catch(reject);
            });
        }
    };
}
export function useAddComment() {
    var commentElement = useCommentUtils();
    return {
        addComment: function (request) {
            return new Promise(function (resolve, reject) {
                if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.addComment))
                    return reject(new Error('Velt SDK is not initialized.'));
                commentElement.addComment(request).then(resolve).catch(reject);
            });
        }
    };
}
export function useUpdateComment() {
    var commentElement = useCommentUtils();
    return {
        updateComment: function (request) {
            return new Promise(function (resolve, reject) {
                if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.updateComment))
                    return reject(new Error('Velt SDK is not initialized.'));
                commentElement.updateComment(request).then(resolve).catch(reject);
            });
        }
    };
}
export function useDeleteComment() {
    var commentElement = useCommentUtils();
    return {
        deleteComment: function (request) {
            return new Promise(function (resolve, reject) {
                if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.deleteComment))
                    return reject(new Error('Velt SDK is not initialized.'));
                commentElement.deleteComment(request).then(resolve).catch(reject);
            });
        }
    };
}
export function useGetComment() {
    var commentElement = useCommentUtils();
    return {
        getComment: function (request) {
            return new Promise(function (resolve, reject) {
                if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.getComment))
                    return reject(new Error('Velt SDK is not initialized.'));
                commentElement.getComment(request).then(resolve).catch(reject);
            });
        }
    };
}
export function useAddAttachment() {
    var commentElement = useCommentUtils();
    return {
        addAttachment: function (request) {
            return new Promise(function (resolve, reject) {
                if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.addAttachment))
                    return reject(new Error('Velt SDK is not initialized.'));
                commentElement.addAttachment(request).then(resolve).catch(reject);
            });
        }
    };
}
export function useDeleteAttachment() {
    var commentElement = useCommentUtils();
    return {
        deleteAttachment: function (request) {
            return new Promise(function (resolve, reject) {
                if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.deleteAttachment))
                    return reject(new Error('Velt SDK is not initialized.'));
                commentElement.deleteAttachment(request).then(resolve).catch(reject);
            });
        }
    };
}
export function useGetAttachment() {
    var commentElement = useCommentUtils();
    return {
        getAttachment: function (request) {
            return new Promise(function (resolve, reject) {
                if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.getAttachment))
                    return reject(new Error('Velt SDK is not initialized.'));
                commentElement.getAttachment(request).then(resolve).catch(reject);
            });
        }
    };
}
export function useDeleteRecording() {
    var commentElement = useCommentUtils();
    return {
        deleteRecording: function (request) {
            return new Promise(function (resolve, reject) {
                if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.deleteRecording))
                    return reject(new Error('Velt SDK is not initialized.'));
                commentElement.deleteRecording(request).then(resolve).catch(reject);
            });
        }
    };
}
export function useGetRecording() {
    var commentElement = useCommentUtils();
    return {
        getRecording: function (request) {
            return new Promise(function (resolve, reject) {
                if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.getRecording))
                    return reject(new Error('Velt SDK is not initialized.'));
                commentElement.getRecording(request).then(resolve).catch(reject);
            });
        }
    };
}
export function useAddReaction() {
    var commentElement = useCommentUtils();
    return {
        addReaction: function (request) {
            return new Promise(function (resolve, reject) {
                if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.addReaction))
                    return reject(new Error('Velt SDK is not initialized.'));
                commentElement.addReaction(request).then(resolve).catch(reject);
            });
        }
    };
}
export function useDeleteReaction() {
    var commentElement = useCommentUtils();
    return {
        deleteReaction: function (request) {
            return new Promise(function (resolve, reject) {
                if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.deleteReaction))
                    return reject(new Error('Velt SDK is not initialized.'));
                commentElement.deleteReaction(request).then(resolve).catch(reject);
            });
        }
    };
}
export function useToggleReaction() {
    var commentElement = useCommentUtils();
    return {
        toggleReaction: function (request) {
            return new Promise(function (resolve, reject) {
                if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.toggleReaction))
                    return reject(new Error('Velt SDK is not initialized.'));
                commentElement.toggleReaction(request).then(resolve).catch(reject);
            });
        }
    };
}
/**
 * @deprecated Use useCommentEventCallback hook instead.
 */
export function useCommentActionCallback(action) {
    var commentElement = useCommentUtils();
    var _a = useState(null), data = _a[0], setData = _a[1];
    var subscriptionRef = useRef(null);
    var memoizedAction = useMemo(function () { return action; }, [action]);
    useEffect(function () {
        var _a;
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.on))
            return;
        if (subscriptionRef.current) {
            subscriptionRef.current.unsubscribe();
        }
        var subscription = (_a = commentElement === null || commentElement === void 0 ? void 0 : commentElement.on(memoizedAction)) === null || _a === void 0 ? void 0 : _a.subscribe(function (data) {
            setData(data);
        });
        // Store the new subscription
        subscriptionRef.current = subscription;
        // Cleanup function
        return function () {
            if (subscriptionRef.current) {
                subscriptionRef.current.unsubscribe();
            }
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.on, memoizedAction]);
    return data;
}
export function useCommentEventCallback(action) {
    var commentElement = useCommentUtils();
    var _a = useState(null), data = _a[0], setData = _a[1];
    var subscriptionRef = useRef(null);
    var memoizedAction = useMemo(function () { return action; }, [action]);
    useEffect(function () {
        var _a;
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.on))
            return;
        if (subscriptionRef.current) {
            subscriptionRef.current.unsubscribe();
        }
        var subscription = (_a = commentElement === null || commentElement === void 0 ? void 0 : commentElement.on(memoizedAction)) === null || _a === void 0 ? void 0 : _a.subscribe(function (data) {
            setData(data);
        });
        // Store the new subscription
        subscriptionRef.current = subscription;
        // Cleanup function
        return function () {
            if (subscriptionRef.current) {
                subscriptionRef.current.unsubscribe();
            }
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.on, memoizedAction]);
    return data;
}
